/**
 * @generated SignedSource<<15ba3ca76499b4d01b011050670f06b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "authenticateViaTotp",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TOTPWallMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TOTPWallMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "36496e74662e41ea87843ba639baa7be",
    "id": null,
    "metadata": {},
    "name": "TOTPWallMutation",
    "operationKind": "mutation",
    "text": "mutation TOTPWallMutation(\n  $input: AuthenticateViaTotpInput!\n) {\n  authenticateViaTotp(input: $input)\n}\n"
  }
};
})();

node.hash = "2af3b8b591c18b78fc4868d1a9f11be5";

module.exports = node;
